<!-- 首页 -->
<template>
  <div class="frame">
    <div id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
          <img :src="URL + item.sourceUrl" :alt="item.name" class="post" />
          <div class="more" @click="linkTo(item)" v-if="item.hrefUrl">
            查看更多 +
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="container">
      <div class="box1">
        <div class="content">
          <div class="top w1200">
            <div class="left">
              <div class="line"></div>
              <div class="title">公司简介</div>
              <div class="en">Company Profile</div>
            </div>
            <div class="right">
              <div class="name">四川志扬工程咨询服务有限公司</div>
              <div class="line"></div>
              <div class="intro">
                简称志扬咨询，成立于2013年，是一家致力于打造“一站式云控数智整体项目全过程工程咨询顾问服务”的专业咨询平台，是行业内极具前瞻性、创新思维的工匠型企业。历年来，志扬咨询始终坚持以品质服务助力国家高质量发展，是工程咨询界一颗冉冉升起的新星。
              </div>
              <div style="text-align: right">
                <button class="more" @click="navTo('/about/intro')">
                  查看更多 +
                </button>
              </div>
            </div>
          </div>
          <div id="intro">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in introList"
                :key="item.id"
              >
                <img :src="URL + item.newsImageUrl" class="post" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
      <div class="box2">
        <div class="title-box">
          <div class="en">Business Introduction</div>
          <div class="title">业务介绍</div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="list-wrap">
            <div
              class="list w1200"
              :style="{
                transform: 'translateX(-' + businessSwiperIdx * 300 + 'px)',
              }"
            >
              <div
                :class="{ item: true, active: businessActiveIdx == idx }"
                v-for="(item, idx) in businessList"
                :key="item.title"
                @mouseenter="showBusiness(idx)"
              >
                <img :src="item.icon" alt="咨询项目" class="bg" />
                <div class="title">{{ item.title }}</div>
                <div class="point"></div>
                <button class="more" @click="navTo(item.path)">查看更多</button>
              </div>
            </div>
          </div>
          <!-- <div class="desc w1200">
            {{ businessList[businessActiveIdx].desc }}
          </div> -->
          <div class="change">
            <img
              class="turn"
              :style="{ opacity: businessSwiperIdx == 0 ? 0.5 : 1 }"
              src="../assets/turn.png"
              alt=""
              @click="businessTurnLeft"
            />
            <img
              class="turn right"
              :style="{ opacity: businessSwiperIdx >= maxSwiper ? 0.5 : 1 }"
              src="../assets/turn.png"
              alt=""
              @click="businessTurnRight"
            />
          </div>
        </div>
      </div>
      <div class="box3">
        <div class="title-box">
          <div class="en">Representative case</div>
          <div class="title">代表案例</div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div id="case">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in caseList"
                :key="item.id"
                @click="getCaseDetail(item)"
              >
                <img :src="URL + item.newsImageUrl" class="post" />
                <div class="title">{{ item.title }}</div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <div class="out-project">
            <div class="in-projuet">
              <div
                class="projects"
                :style="{
                  transform: 'translateX(' + -caseActiveIdx * 510 + 'px)',
                }"
              >
                <div class="project" v-for="item in caseList" :key="item.id">
                  <div class="title">{{ item.title }}</div>
                  <div class="line"></div>
                  <div class="desc">{{ item.description }}</div>
                  <button class="more" @click="navTo('/case/case')">
                    查看更多案例 >>
                  </button>
                </div>
              </div>
            </div>
            <div class="case-paginations">
              <div class="kuang">
                <i
                  class="left el-icon-arrow-left"
                  @click="caseTurn('left')"
                ></i>
              </div>
              <div class="kuang">
                <i
                  class="right el-icon-arrow-right"
                  @click="caseTurn('right')"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box4">
        <div class="title-box">
          <div class="en">Scientific and technological innovation</div>
          <div class="title">科技创新</div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="in w1200">
            <div class="types">
              <div class="type" @click="navTo('/innovate/productCenter')">
                <img
                  class="post"
                  src="http://api.zyzxgc.cn/file/static/box4_1.png"
                  alt=""
                />
                <div class="text">
                  <div class="num">01</div>
                  <div class="name">产品中心 >></div>
                </div>
              </div>
              <div class="type" @click="navTo('/innovate/controlPlatform')">
                <img
                  class="post"
                  src="http://api.zyzxgc.cn/file/static/box4_2.png"
                  alt=""
                />
                <div class="text">
                  <div class="num">02</div>
                  <div class="name">云控平台 >></div>
                </div>
              </div>
              <div class="type" @click="navTo('/innovate/academe')">
                <img
                  class="post"
                  src="http://api.zyzxgc.cn/file/static/box4_3.png"
                  alt=""
                />
                <div class="text">
                  <div class="num">03</div>
                  <div class="name">志扬学苑 >></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box5 w1200">
        <div class="news-title">
          <div class="title">新闻资讯</div>
          <div class="more" @click="getMoreNews">查看更多>></div>
        </div>
        <div class="content">
          <div id="new">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in newsList"
                :key="item.id"
                @click="navToDetail(item)"
              >
                <img
                  :src="URL + item.newsImageUrl.split(',')[0]"
                  class="post"
                />
                <div class="mask">
                  <div class="title">{{ item.title }}</div>
                  <div class="time">
                    {{ item.publishTime || item.createTime | handleTime }}
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <div class="news">
            <div
              :class="{ new: true, first: [0, 1].includes(idx) }"
              v-for="(item, idx) in newsList"
              :key="item.id"
              @click="navToDetail(item)"
            >
              <div class="post" v-if="[0, 1].includes(idx)">
                <img
                  :src="URL + item.newsImageUrl.split(',')[0]"
                  :alt="item.title"
                />
              </div>
              <div class="text">
                <div class="title">{{ item.title }}</div>
                <div class="time">
                  {{ item.publishTime || item.createTime | handleTime }}
                </div>
                <div class="desc">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box6">
        <div class="content w1200">
          <p>留言咨询</p>
          <div class="ipt-frame">
            <input
              type="text"
              placeholder="姓名"
              class="ipt"
              v-model="message.userName"
            />
            <input
              class="ipt"
              type="number"
              placeholder="手机"
              v-model="message.phone"
            />
            <input
              type="text"
              placeholder="公司名称"
              class="ipt"
              v-model="message.companyName"
            />
            <input
              type="text"
              placeholder="所属行业"
              class="ipt"
              v-model="message.industry"
            />
          </div>
          <button class="submit" @click="submitMessage">提 交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "../util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  data() {
    return {
      URL,
      newsList: [], // 新闻列表
      bannerList: [],
      introList: [], // 企业简介
      businessList: [
        {
          title: "产品类别",
          icon: "http://api.zyzxgc.cn/file/static/business_icon2.png",
          desc: "咨询项目内容简述咨询项目内容简述咨询项目内容简",
          path: "/product/productType",
        },
        {
          title: "品控体系",
          icon: "http://api.zyzxgc.cn/file/static/business_icon3.png",
          desc: "咨询项目内容简",
          path: "/product/qualityControl",
        },
        {
          title: "项目各阶段服务产品",
          icon: "http://api.zyzxgc.cn/file/static/business_icon4.png",
          desc: "容简述咨询项目内容简述咨询项目内容简容简述咨询项目内容简述咨询项目内容简",
          path: "/product/productType?tab=1",
        },
        {
          title: "风控预警",
          icon: "http://api.zyzxgc.cn/file/static/business_icon5.png",
          desc: "容简述咨询项目内容简述咨询项目内容简",
          path: "/product/warning",
        },
        {
          title: "价值再造体系",
          icon: "http://api.zyzxgc.cn/file/static/business_icon6.png",
          desc: "容简述咨询项目内容简述咨询项",
          path: "/product/valueSystem",
        },
      ],
      businessActiveIdx: 0, // 业务激活下标
      businessSwiperIdx: 0, // 业务轮播下标
      maxSwiper: 0, // 最大业务轮播下标
      caseSwiper: null,
      caseList: [],
      caseActiveIdx: 0, // 案例swiper激活下标
      message: {
        userName: "",
        phone: "",
        companyName: "",
        industry: "",
        type: 2,
      },
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  created() {},
  mounted() {
    this.getBanner();
    this.getNews();
    this.getIntro();
    this.getCase();

    this.maxSwiper = this.businessList.length - 4 || 0;
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: -1 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        effect: "fade",
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 企业简介图片
    async getIntro() {
      let res = await this.$api.getIntroList();
      this.introList = res.data;
      setTimeout(() => {
        this.initSlider();
      }, 10);
    },
    initSlider() {
      if (this.isMobile) {
        // 手机端
        new window.Swiper("#intro", {
          loop: true,
          autoplay: true,
          pagination: {
            el: ".swiper-pagination",
          },
        });
        return;
      }
      new window.Swiper("#intro", {
        loop: true,
        autoplay: true,
        centeredSlides: true,
        slidesPerView: 2.5,
        spaceBetween: -90,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 业务介绍鼠标交互
    showBusiness(idx) {
      this.businessActiveIdx = idx;
    },
    // 业务介绍轮播
    businessTurnLeft() {
      if (this.businessSwiperIdx == 0) return;
      this.businessSwiperIdx--;
    },
    businessTurnRight() {
      if (this.businessSwiperIdx >= this.maxSwiper) return;
      this.businessSwiperIdx++;
    },
    // 案例左右箭头点击触发swiper
    caseTurn(type) {
      if (type == "left") {
        this.caseSwiper.slidePrev();
      } else {
        this.caseSwiper.slideNext();
      }
    },
    // banner链接跳转
    linkTo(item) {
      if (item.hrefUrl) {
        window.open(item.hrefUrl);
      }
    },
    // 获取新闻动态列表
    async getNews() {
      const params = {
        pageIndex: 1,
        pageSize: 5,
        newsCode: "4950cb5c2ecb4f2a92e07e1598f5687e", // 父级code
      };
      let res = await this.$api.getNewsList(params);
      this.newsList = res.data.list;
      setTimeout(() => {
        this.initNewsSwiper();
      }, 10);
    },
    getMoreNews() {
      window.scrollTo({ top: 0 });
      this.$router.push("/news/company");
    },
    async getCase() {
      const params = {
        pageIndex: 1,
        pageSize: 5,
        newsCode: "1dc2a7459e43405c90c19a0a37d6f8ca", // 父级code
      };
      let res = await this.$api.getCaseList(params);
      this.caseList = res.data.list;
      setTimeout(() => {
        this.initProjectSwiper();
      }, 10);
    },
    // 初始化案例swiper
    initProjectSwiper() {
      if (this.isMobile) {
        // 手机端
        new window.Swiper("#case", {
          loop: true,
          autoplay: true,
          pagination: {
            el: ".swiper-pagination",
          },
        });
        return;
      }
      let vm = this;
      const offset = window.innerWidth > 1400 ? 530 : 430;
      this.caseSwiper = new window.Swiper("#case", {
        loop: true,
        slidesOffsetBefore: offset,
        autoplay: {
          delay: 5000,
        },
        // centeredSlides: true,
        slidesPerView: 1.7,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.caseActiveIdx = this.realIndex;
          },
        },
      });
    },
    // 案例详情
    getCaseDetail(item) {
      let prefixPath = "";
      const codeArr = item.newsCode.split("#");
      const newsCode = codeArr[codeArr.length - 1];
      if (newsCode == "866300f6ee6d4a7ab0535789a2524f33") {
        // 公司业绩
        prefixPath = "/case/case/caseDetail";
      } else {
        // 代表案例
        prefixPath = "/case/performance/performanceDetail";
      }
      this.$router.push(prefixPath + "/" + item.id);
    },
    // 初始化新闻swiper
    initNewsSwiper() {
      new window.Swiper("#new", {
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 前往新闻详情
    navToDetail(item) {
      window.scrollTo({ top: 0 });
      this.$router.push("/news/newDetail/" + item.id);
    },
    // 快捷导航
    navTo(path) {
      window.scrollTo({ top: 0 });
      this.$router.push(path);
    },
    submitMessage() {
      const reg = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      if (!reg.test(this.message.phone)) {
        this.$notify.error({
          title: "提示",
          message: "请填入正确的手机号码！",
        });
        return;
      }
      this.$api.addFeedback(this.message).then((res) => {
        if (res.code == 0) {
          this.$notify.success({
            title: "提示",
            message: "留言提交成功！我们将在收到消息后会尽快与您联系！",
          });

          Object.assign(this.$data.message, this.$options.data().message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.more {
  cursor: pointer;
}
.frame {
  width: 100%;
  background-color: #fff;

  #banner {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;

    .swiper-pagination {
      bottom: 25%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .more {
      width: 160px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 22px;
      border-radius: 5px;
      color: #fff;
      position: absolute;
      right: 20%;
      bottom: 25%;
      cursor: pointer;

      &::after {
        content: "";
        width: 100%;
        height: 8px;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: skew(40deg);
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }

  .container {
    .title-box {
      color: #454545;
      text-align: center;
      margin-top: 60px;

      .en {
        font-size: 18px;
        margin-bottom: 25px;
      }
      .title {
        font-size: 44px;
      }
      .line {
        width: 3px;
        height: 28px;
        background: #2b6cdb;
        margin: 30px auto 0;
      }
    }
    .box1 {
      background-image: url("http://api.zyzxgc.cn/file/static/home_bg1.png");
      background-size: cover;
      background-position-x: center;

      &::before {
        content: "";
        display: table;
      }
      .content {
        &::after {
          content: "";
          display: table;
        }
        .top {
          margin: 130px auto;
          display: flex;

          .left {
            flex-shrink: 0;
            width: 260px;
            padding: 0 40px;
            box-sizing: border-box;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: #5e5d5d;

            .line {
              width: 58px;
              height: 3px;
              background: #5e5d5d;
            }
            .title {
              font-size: 44px;
              margin-top: 25px;
            }
            .en {
              font-size: 18px;
              margin-top: 25px;
            }
          }
          .right {
            margin-left: 35px;

            .name {
              color: $theme;
              font-size: 24px;
            }
            .line {
              width: 39px;
              height: 3px;
              background-color: $theme;
              margin: 60px 0;
            }
            .intro {
              color: #5e5d5d;
              text-indent: 2em;
              line-height: 30px;
            }
            .more {
              width: 152px;
              height: 45px;
              line-height: 45px;
              text-align: center;
              background-color: #053a7a;
              color: #fff;
              font-size: 14px;
              cursor: pointer;
              margin-top: 70px;
            }
          }
        }
        #intro {
          width: 100%;
          height: 650px;
          max-height: 63vh;
          margin-bottom: 140px;
          position: relative;
          overflow: hidden;

          :deep(.swiper-slide) {
            transform: scale(0.9);
            transition: transform 0.5s;
          }
          :deep(.swiper-slide-duplicate-active),
          :deep(.swiper-slide-active) {
            transform: scale(1);
            z-index: 20;
          }

          .post {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: right;
          }
        }
      }
    }

    .box2 {
      height: 100vh;
      background-image: url("http://api.zyzxgc.cn/file/static/home_bg2.png");
      background-size: cover;
      background-position-x: center;

      &::before {
        content: "";
        display: table;
      }

      .title-box {
        color: #fff;

        .line {
          background: #fff;
        }
      }

      .content {
        margin-top: 110px;

        .list-wrap {
          width: 100%;
          margin-bottom: 70px;
          overflow: hidden;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 260px;
            width: 100%;
            height: 2px;
            background-color: #fff;
          }
        }
        .list {
          display: flex;
          transition: transform 0.3s ease;
          position: relative;
          z-index: 2;

          .item {
            width: 300px;
            flex-shrink: 0;
            color: #ffffff;
            overflow: hidden;
            text-align: center;
            position: relative;

            .bg {
              width: auto;
              height: 62px;
            }
            .title {
              font-size: 24px;
              margin: 76px 0;
            }
            .point {
              width: 20px;
              height: 20px;
              box-sizing: border-box;
              margin: 0 auto 35px;
              background: #7edfef;
              border-radius: 50%;
              border: 3px solid #ffffff;
              opacity: 0;
            }
            .more {
              width: 140px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              border: 1px solid #ffffff;
              background-color: transparent;
              opacity: 0.5;
              cursor: pointer;
            }
          }
          .active {
            .title {
              transform: scale(1.4);
            }
            .point {
              opacity: 1;
            }
            .more {
              opacity: 1;
              background-color: rgba(255, 255, 255, 0.2);
            }
          }
        }
        .desc {
          color: #ffffff;
          line-height: 24px;
          margin-bottom: 65px;
          text-indent: 2em;
        }
        .change {
          display: flex;
          justify-content: center;

          .turn {
            width: 28px;
            cursor: pointer;
          }
          .right {
            transform: rotate(180deg);
            margin-left: 40px;
          }
        }
      }
    }

    .box3 {
      background-image: url("http://api.zyzxgc.cn/file/static/building_bg.png");
      background-size: cover;

      &::before,
      &::after {
        content: "";
        display: table;
      }

      .content {
        margin: 60px 0 130px;
        position: relative;

        #case {
          width: 1250px;
          height: 500px;
          position: relative;
          overflow: hidden;

          .swiper-slide {
            cursor: pointer;
            position: relative;
          }

          .post {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .title {
            color: #fff;
            background-image: linear-gradient(to bottom, transparent, #333);
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 10px 5px;
            @include ellipsis;
            display: none;
          }
        }
        .out-project {
          position: absolute;
          bottom: -30px;
          right: 10%;
          z-index: 5;
        }
        .in-projuet {
          width: 510px;
          height: 340px;
          background-color: $theme;
          overflow: hidden;
        }

        .case-paginations {
          color: #fff;
          box-shadow: 0 0 5px #999;
          position: absolute;
          left: -49px;
          bottom: 0;
          display: flex;
          align-items: center;

          .number {
            margin: 0 20px;
          }
          .kuang {
            width: 49px;
            height: 49px;
            color: #333;
            font-size: 25px;
            background-color: #fff;
            cursor: pointer;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;

            & + .kuang {
              border-left: 1px solid #eee;
            }
            &:active {
              color: #fff;
              background-color: coral;
            }
          }
        }
        .projects {
          height: 100%;
          color: #fff;
          transition: 0.5s;
          display: flex;

          .project {
            width: 510px;
            flex-shrink: 0;
            padding: 30px;
            box-sizing: border-box;
            position: relative;

            .title {
              font-size: 24px;
              margin-bottom: 30px;
            }
            .line {
              width: 30px;
              height: 2px;
              background-color: #fff;
              margin-bottom: 30px;
            }
            .desc {
              max-height: 347px;
              line-height: 24px;
              color: #fefefe;
              font-size: 14px;
              text-indent: 2em;
            }
            .more {
              width: 150px;
              color: #fff;
              background-color: transparent;
              text-align: center;
              cursor: pointer;
              position: absolute;
              right: 50px;
              bottom: 50px;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    .box4 {
      &::before {
        content: "";
        display: table;
      }

      .content {
        background-image: url("http://api.zyzxgc.cn/file/static/home_bg4.png");
        background-size: cover;
        margin-top: 60px;

        .in {
          padding: 60px 0;

          .types {
            display: flex;
            display: flex;
            justify-content: space-between;

            .type {
              max-height: 70vh;
              height: 720px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              cursor: pointer;
              transition: 0.5s;

              &:hover {
                transform: translateY(-20px);
              }

              &:nth-child(2n) {
                flex-direction: column-reverse;
              }

              .post {
                width: 380px;
                height: 84%;
                object-fit: cover;
              }
              .text {
                color: #fff;
                position: relative;

                .num {
                  font-size: 90px;
                  opacity: 0.3;
                  line-height: 0.8;
                }
                .name {
                  font-size: 24px;
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  z-index: 5;
                }
              }
            }
          }
        }
      }
    }
    .box5 {
      padding: 80px 0 60px;

      .news-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #c8c6c6;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 74px;
          height: 2px;
          background: $theme;
          position: absolute;
          left: 0;
          bottom: 0;
        }

        .title {
          color: #333333;
          font-size: 36px;
        }
        .more {
          font-size: 14px;
        }
      }
      .content {
        height: 640px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;

        #new {
          width: 440px;
          height: 100%;
          position: relative;
          overflow: hidden;

          .swiper-slide {
            cursor: pointer;
          }

          .post {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .mask {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            bottom: 0;
            color: #fff;
            background-image: linear-gradient(to top, $theme, transparent);

            .title {
              padding-top: 6px;
              font-size: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .time {
              padding-bottom: 20px;
              font-size: 13px;
            }
          }
        }

        .news {
          margin-left: 20px;
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          flex-direction: column;

          .new {
            width: 260px;
            height: 200px;
            box-shadow: 0px 3px 2px 0px rgba(7, 14, 40, 0.1);

            &:hover {
              cursor: pointer;
              border-color: $theme;

              .title {
                text-decoration: underline;
              }

              .post img {
                transform: scale(1.1);
              }
            }

            .text {
              padding: 20px 10px;
              box-sizing: border-box;

              .title {
                color: #666666;
                line-height: 24px;
                font-size: 18px;
                font-weight: 500;
                @include ellipsis;
              }
              .time {
                color: #999999;
                font-size: 13px;
                margin: 15px 0 20px;
              }
              .desc {
                font-size: 14px;
                color: #666666;
                line-height: 22px;
                @include mutipleEllipsis(4);
              }
            }
          }
          .first {
            width: 450px;
            height: auto;
            margin-right: 20px;

            .text {
              padding: 10px;

              .time {
                margin: 5px 0;
              }
            }
            .post {
              width: 100%;
              height: 200px;
              flex-shrink: 0;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: 0.5s;
              }
            }
            .text .desc {
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
    .box6 {
      background-color: #eeeef0;

      .content {
        padding: 30px 0;
        display: flex;
        align-items: center;

        p {
          font-size: 28px;
          color: #333;
          margin-right: 20px;
        }
        .ipt-frame {
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .ipt,
          .textarea {
            background-color: #f3f2f2;
            border: 1px solid #d7d5d5;
            font-size: 12px;
          }

          .ipt {
            width: 24%;
            height: 35px;
            text-indent: 1em;
          }
          .textarea {
            width: 100%;
            height: 60px;
            margin-top: 10px;
            text-indent: 1em;
            padding: 8px 0;
            box-sizing: border-box;
          }
        }
        .submit {
          height: fit-content;
          white-space: nowrap;
          padding: 10px 40px;
          color: #fff;
          background-color: $theme;
          border: none;
          outline: none;
          margin-left: 20px;

          &:hover {
            cursor: pointer;
          }
          &:active {
            transform: scale(0.9);
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .frame .container {
    .box1 .content #intro {
      height: 520px;
    }
    .box3 .content {
      #case {
        width: 1000px;
        height: 350px;
      }
      .out-project {
        bottom: -150px;
        right: 2%;
      }
      .in-projuet {
        height: 280px;
      }
      .projects {
        .project {
          padding: 20px;

          .title {
            font-size: 20px;
          }
          .desc {
            max-height: 100px;
            overflow: auto;
          }
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    #banner {
      height: auto;

      .swiper-pagination {
        bottom: 10px;
      }
      .swiper-slide {
        .post {
          width: 100%;
          height: auto;
        }
        .more {
          display: none;
        }
      }
    }
    .container {
      .title-box {
        margin-top: 40px;

        .title {
          font-size: 24px;
        }
        .en {
          font-size: 14px;
          margin-bottom: 10px;
        }
        .line {
          height: 20px;
          margin: 20px auto;
        }
      }
      .box1 {
        .content {
          .top {
            margin: 40px auto;

            .left {
              display: none;
            }
            .right {
              margin: 0 10px;

              .line {
                margin: 20px 0;
              }
              .name {
                font-size: 20px;
              }
              .intro {
                font-size: 14px;
              }
              .more {
                width: 100px;
                height: 30px;
                line-height: 30px;
                font-size: 12px;
                margin-top: 30px;
              }
            }
          }
          #intro {
            height: 200px;
            margin-bottom: 50px;
          }
        }
      }
      .box2 {
        height: auto;
        padding-bottom: 5px;

        .content {
          margin-top: 80px;

          .list-wrap {
            overflow: auto;

            &::after {
              display: none;
            }
          }
          .list {
            .item {
              width: 45%;

              .bg {
                height: 40px;
              }
              .title {
                margin: 20px 0;
                font-size: 18px;
              }
              .more {
                width: 100px;
                height: 25px;
                line-height: 25px;
                font-size: 14px;
              }
            }
            .active {
              .title {
                font-size: 16px;
              }
            }
          }
          .change {
            display: none;
          }
        }
      }
      .box3 {
        .content {
          margin: 40px 0;

          #case {
            width: 100%;
            height: 300px;

            .title {
              display: block;
            }
            .swiper-pagination {
              bottom: 36px;
            }
          }
          .out-project {
            display: none;
          }
        }
      }
      .box4 {
        .content {
          .in {
            .types {
              justify-content: space-around;

              .type {
                width: 30%;
                height: 300px;

                .post {
                  width: 100%;
                  height: auto;
                }
                .text .name {
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
      .box5 {
        padding: 40px 0;

        .news-title {
          padding: 10px;

          .title {
            font-size: 24px;
          }
        }
        .content {
          height: 300px;

          .news {
            display: none;
          }
        }
      }
      .box6 {
        .content {
          flex-direction: column;

          p {
            font-size: 24px;
            margin-right: 0;
            margin-bottom: 10px;
          }
          .ipt-frame {
            width: 80%;
            flex-direction: column;

            .ipt {
              width: 100%;

              & + .ipt {
                margin-top: 7px;
              }
            }
          }
          .submit {
            margin-left: 0;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
